<template>
	<div class="downloadfile">
		<el-table
			:data="resultDataList"
			style="width: 100%"
			:stripe="true">
			<el-table-column
				prop="name"
				label="报告名称">
			</el-table-column>
			<el-table-column
				prop="date"
				label="发布时间"
				width="100">
			</el-table-column>
			<el-table-column
				label="下载"
				width="80">
				<template slot-scope="scope">
					<el-button @click="downloadfile(scope.row)">
						<i class="el-icon-download"></i>
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-row style="margin-top: 10px;">
		  <el-col :span="4">
				<el-button type="primary" plain @click="downloadall()">
					全部下载
				</el-button>
			</el-col>
		  <el-col :span="20">
				<el-row class="pagediv" style="justify-content: flex-end;">
					<el-pagination
						@size-change="changePageSize"
						@current-change="changeSearchPage"
						:current-page="pageNum"
						:page-size="pageSize"
						layout="total,  prev, pager, next"
						:total="totalResultCount">
					</el-pagination>
					
				</el-row>
				
			</el-col>
		</el-row>
		
	</div>
	
</template>

<script>
	export default {
		data() {
			return {
				tableData:window.FILE_CONFIG['downloadlist'],
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
			}
		},
		mounted() {
			this.searchfnc();
		},
		methods: {
			downloadfile:function(row){
				// window.location.href='/pdf/download/'+row.name+row.type;
				var a = document.createElement('a');
				a.setAttribute('href', '/pdf/download/'+row.name+row.type);
				a.setAttribute('style', 'display:none');  
				a.setAttribute('target', '_blank');  
				document.body.appendChild(a);
				a.click();
				a.parentNode.removeChild(a); 
			},
			downloadall:function(){
				var a = document.createElement('a');
				a.setAttribute('href', '/pdf/download/'+window.FILE_CONFIG['downloadall']);
				a.setAttribute('style', 'display:none');  
				a.setAttribute('target', '_blank');  
				document.body.appendChild(a);
				a.click();
				a.parentNode.removeChild(a); 
				// window.location.href='/pdf/download/二十大系列报告pdf（10.10）.rar';
			},
			searchfnc: function() {
				this.resultDataList = this.tableData.slice((this.pageNum-1)*this.pageSize,this.pageNum*this.pageSize);
				this.totalResultCount = this.tableData.length;
			},
			changePageSize:function(pagesize){
				this.pageSize=pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.searchfnc();
			},
		}
	}
</script>

<style>
</style>
